import { getExamineePaymentInfo } from '../../common/request'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ResponseCode from '../../common/response-code'
import { Descriptions, Spin } from 'antd'

const PaymentInformation = (props) => {
  const selectedExam = useSelector(state => state.examInfo.selectedExam)
  const [orderInfo, setOrderInfo] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (selectedExam.id) {
      getPaymentInformation(props.applyInfo.id)
    }
  }, [selectedExam, props.templateField, props.applyInfo, props.modalVisible])

  const getPaymentInformation = (applyInfoId) => {
    setLoading(true)
    getExamineePaymentInfo({ applyInfoId: applyInfoId }).then(res => {
      if (res.code === ResponseCode.success) {
        setOrderInfo(res.data)
      }
    }).finally(() => {
      setLoading(false)
    })
  }

  const getPaymentStatus = (payStatus) => {
    let message = ''
    let className = ''

    switch (payStatus) {
      case -1:
        message = '申请退款成功'
        className = 'text-primary'
        break
      case 0:
        message = '未缴费'
        className = 'text-warning'
        break
      case 1:
        message = '已缴费'
        className = 'text-success'
        break
      case 2:
        message = '不需缴费'
        className = 'text-primary'
        break
      case 3:
        message = '贫困生免费'
        className = 'text-primary'
        break
    }

    return (
      <div className={className}>
        {message}
      </div>
    )
  }

  return (
    <Spin spinning={ loading } className="px-4 py-3">
      <Descriptions title="缴费信息">
        <Descriptions.Item label="考试名称">{ selectedExam.name }</Descriptions.Item>
        <Descriptions.Item label="考生姓名">{ props.applyInfo.name }</Descriptions.Item>
        <Descriptions.Item label="支付方式">{ orderInfo.payType }</Descriptions.Item>
        <Descriptions.Item label="支付金额">
          <div className="text-warning font-weight-900">{ orderInfo.amount }</div>
        </Descriptions.Item>
        <Descriptions.Item label="支付状态">{ getPaymentStatus(orderInfo.payStatus) }</Descriptions.Item>
        <Descriptions.Item label="缴费时间">{ orderInfo.payTime }</Descriptions.Item>
        <Descriptions.Item label="微信交易单号" span={3}>{ orderInfo.centerSeqId }</Descriptions.Item>
        <Descriptions.Item label="缴费订单号" span={3}>{ orderInfo.orderNumber }</Descriptions.Item>
      </Descriptions>
    </Spin>
  )
}

export default PaymentInformation
